import { Modal } from "./Modal";

// Themed confirm dialog (replaces window.confirm) built on the shared Modal.
export function ConfirmDialog({
  title,
  message,
  confirmLabel = "continuar",
  cancelLabel = "cancelar",
  onConfirm,
  onCancel,
}: {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <Modal ariaLabel={title} icon="!" title={title} onClose={onCancel}>
      <div className="space-y-5 p-5">
        <p className="font-mono text-sm leading-relaxed text-mute">{message}</p>
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="rounded border border-line px-4 py-2 font-mono text-xs text-mute hover:border-accent hover:text-accent"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="rounded border border-accent bg-accent/10 px-4 py-2 font-mono text-xs text-accent hover:bg-accent hover:!text-bg"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
}
